import { createSlice } from '@reduxjs/toolkit';
import {userForgotPasswordApi} from '../LoginApi/loginApi';

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(userForgotPasswordApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userForgotPasswordApi.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(userForgotPasswordApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default forgotPasswordSlice.reducer;
